// app/not-found.tsx
"use client";

import Link from "next/link";
import Header from "@/app/components/themes/Header";
import Footer from "@/app/components/themes/Footer";

export default function NotFound() {
  return (
    <>
      <Header />
      <div className="min-h-[70vh] flex items-center justify-center px-4 py-25 mt-10">
        <div className="text-center max-w-md mx-auto">
          <div className="text-9xl font-bold text-[var(--title)] mb-4">404</div>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-[var(--title)] to-transparent mx-auto my-6"></div>
          <h1 className="text-2xl font-bold text-[var(--titleha)] mb-3">صفحه مورد نظر یافت نشد</h1>
          <p className="text-[var(--foreground)] mb-8">
            متاسفیم، صفحه‌ای که به دنبال آن هستید وجود ندارد یا جابه‌جا شده است.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              href="/"
              className="subBtnRe w-[200px] h-[45px] rounded-lg transition-all"
            >
              <i className="ri-home-line ml-2"></i>
              بازگشت به خانه
            </Link>
            <button
              onClick={() => window.history.back()}
              className="normBtn w-[200px] h-[45px] rounded-lg transition-all"
            >
              <i className="ri-arrow-go-back-line ml-2"></i>
              برگشت به صفحه قبل
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}